import Loading from './loading/loading.js';
import Message from './message/message.js';

const components = [];

const element = {
	install:function(vue){
		components.forEach(component => {
	    	vue.component(component.name, component);
	  	});
		vue.prototype.$zloading = Loading;
		vue.prototype.$zmessage = Message;
	}
}

export default element;


// WEBPACK FOOTER //
// ./src/components/element/index.js